import { delay, put, select } from 'redux-saga/effects';
import { Notifications } from 'types';
import { setRoundWinnersDataAction } from 'core/widgets/WinnersTicker/actions';
import {
  jackpotActivitySelector,
  jackpotInfoWinningDrawSelector,
} from 'core/widgets/Jackpot/selectors';
import { OnDisplayWinnersData } from '../types';
import { displayingWinResultSelector } from 'core/widgets/TableSettings';

export function* onDisplayWinnersSaga({ type: notificationType, data }: OnDisplayWinnersData) {
  if (notificationType === Notifications.DISPLAY_WINNERS) {
    const { winners } = data;
    const { stage } = yield select(jackpotActivitySelector);
    const { winDuration } = yield select(jackpotInfoWinningDrawSelector);
    const displayingWinResult: number = yield select(displayingWinResultSelector);

    if (stage && winDuration) {
      yield delay(Number((winDuration as number) + displayingWinResult + 1) * 1000 || 5000);

      yield put(setRoundWinnersDataAction({ winners }));
      return;
    }

    yield put(setRoundWinnersDataAction({ winners }));
  }
}
